import { Box, Tag, Text, useHasUserTag } from '@centra/centra-ui'
import { AvatarInfo, Paragraph } from 'components/shared'
import React, { MouseEvent, useCallback } from 'react'
import { ITask } from 'store/taskManager/model'
import { format, parseISO } from 'date-fns'
import { AlertUrgent, MessageCounter, TaskInfoRow, TaskTitle, UpdatedTask, Wrapper } from './Task.style'

import styled from './Task.module.scss'
import { ArchivedIcon } from './_ArchivedIcon/ArchivedIcon'
import { TaskCompany } from '../../TaskCompany'

export interface ITaskProps {
  task: ITask
  adminView?: boolean
  onActivate: (id: number, e: MouseEvent<any>) => void
  activeTask?: ITask | null
  index?: number
}

const Task = (props: ITaskProps) => {
  const {
    task: {
      id,
      name,
      category,
      status,
      client,
      assigned: { avatar, firstName, lastName, online },
      unreadMessageCount,
      taskUpdateCount,
      urgent,
      createdAt,
    },
    adminView,
    onActivate,
    activeTask,
  } = props

  const creationDate = createdAt && parseISO(createdAt)

  const isClient = useHasUserTag([
    'role.agency-primary-manager',
    'role.agency-manager',
    'role.client-primary-manager',
    'role.client-manager',
  ])

  const handleActivate = useCallback((id: number, e: MouseEvent<any>) => onActivate(id, e), [])

  //Если есть агентство, то отображаем время архивирования агентства, иначе - клиента
  const archivedTime = client?.agencyArchivedAt || client?.archivedAt
  const archivedClientKind =
    !client?.agencyArchivedAt && client?.kind === 'agencyClient' ? 'Клиент агентства' : 'Клиент'
  const showClientArchived = !client?.agencyArchivedAt && client?.archivedAt

  return (
    <Wrapper
      onClick={e => handleActivate(id, e)}
      active={isClient && activeTask?.id === id}
      urgent={!!urgent}
      adminView={adminView}
    >
      {urgent && (
        <AlertUrgent>
          <svg width="16px" height="16px">
            <use xlinkHref="#alert" />
          </svg>
        </AlertUrgent>
      )}
      <TaskTitle title={name} style={{ color: 'black' }}>
        {name}
      </TaskTitle>

      <TaskInfoRow container alignItems={'center'}>
        <Box gap={4} marginBottom={8} marginRight={8} fullWidth className={styled.clientDataContainer}>
          {client && <TaskCompany client={client} />}
        </Box>
        <Box marginBottom={8}>
          <Box column marginRight={8}>
            <Tag id={`task_${activeTask?.id}_category_tag`} variant={'outline'} size={'sm'} view={category.colorAlias}>
              {category.name}
            </Tag>
          </Box>
          <Box column>
            <Tag id={`task_${activeTask?.id}_status_tag`} size={'sm'} view={status.colorAlias}>
              {status.name}
            </Tag>
          </Box>
        </Box>
      </TaskInfoRow>

      <Box justifyContent={'spaceBetween'} alignItems={'center'}>
        <AvatarInfo online={online} avatar={avatar} storage={false} grayscale firstName={firstName} lastName={lastName}>
          <Paragraph size={'sm'} style={{ color: 'black' }}>
            {firstName} {lastName}
          </Paragraph>
        </AvatarInfo>
      </Box>

      {!!taskUpdateCount && <UpdatedTask />}
      {creationDate && (
        <Text id="taskCreationDate" color="basicGreySemiDark" size="caption" className={styled.creationDate}>
          {format(creationDate, 'dd.MM.yy')}
        </Text>
      )}

      {!!unreadMessageCount && <MessageCounter>{unreadMessageCount}</MessageCounter>}
    </Wrapper>
  )
}

export default Task
